{
    "coordinates": [
        48.19739388234848,
        14.215816566499768
    ],
    "tooltip": "Austrian Paratethys",
    "title": "Austrian Paratethys",
    "country": "Austria",
    "period": "Neogene",
    "alt": "TODO"
}
